import { render } from "./App.vue?vue&type=template&id=52eed34a&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=52eed34a&lang=scss"

import exportComponent from "D:\\wamp64\\www\\driver.total.cz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__